import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import AppTableContainer from "@crema/core/AppTableContainer";
import { TransactionsData } from "types/models/master/MasterApp";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";

interface TransactionsTableProps {
  transactions: TransactionsData[];
}

const TransactionsTable: React.FC<TransactionsTableProps> = ({transactions }) => {
  
  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading />
        </TableHead>
        <TableBody>
          {transactions.map((data) => (
            
            <TableItem data={data} key={data.id} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default TransactionsTable;
